import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';
import { AccountStatusService } from '../services/account-status.service';
import { AuthService } from '../services/auth.service';
import { NotificationServiceService } from '../services/notification-service.service';

let isLogoutInProgress = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('accessToken');

  const router = inject(Router);
  const accountStatus = inject(AccountStatusService);
  const authService = inject(AuthService);
  const notificationService = inject(NotificationServiceService);

  // Check whether this is logout API
  const isLogoutApi = req.url.includes('/logout');

  // ALWAYS attach Authorization header if token exists
  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  const finishLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    isLogoutInProgress = false;

    router.navigate(['/account/login']);
  };

  const logoutUser = () => {
    if (isLogoutInProgress) {
      return;
    }

    isLogoutInProgress = true;

    const imei = notificationService.deviceId;

    authService.signout(imei).subscribe({
      next: () => {
        console.log('Logout API Success');
        finishLogout();
      },
      error: (err) => {
        console.log('Logout API Failed', err);
        // Even if logout API fails, clear local session
        finishLogout();
      },
    });
  };

  return next(authReq).pipe(
    tap((event) => {
    if (event instanceof HttpResponse) {
  const res: any = event.body;

  if (event.status === 205) {
    logoutUser();
    return;
  }

  if (res?.responseStatus === 'ACCOUNT_SUSPENDED') {
    accountStatus.setSuspended(true);

    sessionStorage.setItem(
      'SUSPEND_REASON',
      res?.data?.reason || ''
    );

    router.navigate(['/account-suspended']);
  }
}
    }),

    catchError((error: HttpErrorResponse) => {
      // Ignore logout API 401 to prevent infinite logout loop
      if (isLogoutApi) {
        return throwError(() => error);
      }

      switch (error.status) {
        case 401:
          logoutUser();
          break;

        case 403:
          if (error.error?.responseStatus === 'ACCOUNT_SUSPENDED') {
            accountStatus.setSuspended(true);

            sessionStorage.setItem(
              'SUSPEND_REASON',
              error.error?.data?.reason || ''
            );

            router.navigate(['/account-suspended']);
          }
          break;

        case 500:
          router.navigate(['/error']);
          break;
      }

      return throwError(() => error);
    })
  );
};
